import React from 'react';
import '../common/btn1.css';

const Btn1 = (props) => {
    return (
        <>
            <button className={props.b}>
                <span>{props.btntt}</span>
            </button>
        </>
    );
};

export default Btn1;